import * as React from "react";
const SvgFiRrMillSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 9v11c0 .55-.45 1-1 1s-1-.45-1-1V9c0-2.21-1.79-4-4-4-.61 0-1.19.14-1.71.39L13 10.98V20c0 .55-.45 1-1 1s-1-.45-1-1v-4.14l-3.07 7.51c-.16.39-.53.62-.93.62-.13 0-.25-.02-.38-.07a1 1 0 0 1-.55-1.3L11 10.58V9c0-2.21-1.79-4-4-4S3 6.79 3 9v11c0 .55-.45 1-1 1s-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v.53A5.97 5.97 0 0 1 7 3a6.01 6.01 0 0 1 5 2.69c.45-.67 1.02-1.25 1.69-1.69L15.07.63a.998.998 0 1 1 1.85.75l-.68 1.67c.25-.03.5-.05.76-.05 3.31 0 6 2.69 6 6"
    />
  </svg>
);
export default SvgFiRrMillSign;
